export default "__VITE_ASSET__95ed3ce2__"